<template>
  <div class="dimmed">
    <div class="apply-install-checker">
      <div class="popup__content">
        <div class="content__text">
          <i class="icon icon--input-field-size50"></i>
          <p v-html="$t('dashboard.urlInstallChecker.desc')"></p>
        </div>
        <p class="content__input">
          <input type="text" v-model.trim="url"
            :class="{error: urlError}"
            placeholder="e.g. http://www.example.net/pages/?x=1"
            @keyup.enter="onCheckInstallClick">
          <button type="button"
                  @click="onCheckInstallClick">
            {{ $t('common.confirm') }}
          </button>
          <strong v-if="urlError" class="error">{{ urlError }}</strong>
        </p>
        <button class="btn__close" @click="$emit('onCloseClick')">
          <i class="icon icon--close-btn"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { isValidUrl } from '@/libs/validation-helper'

export default {
  name: 'UrlInstallCheckerLayer',
  props: [
    'applyData'
  ],
  data () {
    return {
      url: '',
      urlError: null
    }
  },
  computed: {
  },
  methods: {
    isValidMatchTypeUrl () {
      const apply = this.applyData
      const url = this.url

      if (!url.length) {
        return false
      }

      const applyUrl = apply.url
      const matchType = apply.matchType
      const matchString = apply.matchString || ''

      const startIndex = applyUrl.indexOf('//')
      let domain = applyUrl.slice(startIndex + 2).split('/')[0]

      if (matchType === 'start') {
        return url.indexOf(applyUrl) === 0
      } else {
        if (url.indexOf(domain) < 0) {
          if (domain.indexOf('www') === 0) {
            domain = domain.replace('www', '')
            if (url.indexOf(domain) < 0) {
              return false
            }
          } else {
            return false
          }
        }

        if (matchType === 'end') {
          const revUrl = url.split('').reverse().join('')
          const revMatchString = matchString.split('').reverse().join('')
          return revUrl.indexOf(revMatchString) === 0
        } else if (matchType === 'contains') {
          return url.indexOf(matchString) > -1
        } else if (matchType === 'regexp') {
          try {
            const reg = new RegExp(matchString)
            return reg.test(url)
          } catch (e) {
            return false
          }
        }
      }
    },
    onCheckInstallClick () {
      this.urlError = null

      if (!this.url.length || !isValidUrl(this.url)) {
        this.urlError = this.$t('common.validationErrorText.urlInstallChecker.required')
      } else if (!this.isValidMatchTypeUrl()) {
        this.urlError = this.$t('common.validationErrorText.urlInstallChecker.invalid')
      }

      if (this.urlError) {
        return
      }
      this.$emit('onCheckInstall', this.applyData.id, this.url, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.apply-install-checker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  width: 630px;
  height: 173px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 30px;
  padding-bottom: 12px;

  .content__text {
    @include flexYcenter;
    position: relative;
    left: -11px;
    font-weight: 500;

    p {
      margin-left: 3px;
      font-size: 14px;
      line-height: 1.43;
      color: #2f2f2f;
    }
  }

  .content__input {
    margin-top: 21px;

    input {
      width: 480px;
      height: 38px;
      border-radius: 6px;
      border: solid 1px #bbb;
      background-color: #ffffff;
      box-sizing: border-box;
      font-size: 14px;
      padding: 12px;
      &.error {
        border-color: $errorColor;
      }
    }

    button {
      @include buttonTypeNormal;
      line-height: 38px;
      border: solid 1px #bbb;
      margin-left: 5px;
      font-weight: 500;
    }

    strong {
      @include validErrorText;
      margin-top: 4px;
      display: inline-block;
    }
  }

  .btn__close {
    padding: 15px;
    position: absolute;
    top: 0;
    right: 0;
    i {
      pointer-events: none;
      background-position: center;
    }
  }
}
</style>
